const favoritePlaces = [
  { name: 'Hutan Kota GBK', score: 82, note: 'Tersimpan karena cocok untuk lari pagi dan kualitas udara relatif baik.' },
  { name: 'Tebet Eco Park', score: 79, note: 'Cocok untuk keluarga, edukasi ruang hijau, dan aktivitas santai.' },
  { name: 'Menteng Park', score: 74, note: 'Alternatif pusat kota dengan akses mudah untuk sore hari.' },
];

const notifications = [
  { title: 'Suhu siang hari meningkat', body: 'Disarankan memajukan aktivitas luar ruang ke pagi atau sore hari.' },
  { title: 'Ada kegiatan komunitas akhir pekan', body: 'Aksi bersih taman dan edukasi lingkungan tersedia di menu Aksi.' },
  { title: 'Story edukasi siap dibagikan', body: 'Template story terbaru dapat dipakai untuk kampanye #JakComfort.' },
];

export function FavoritesPage() {
  return (
    <div className="app-page favorites-page">
      <header className="app-page__header">
        <div>
          <span className="eyebrow">Favorit & Notifikasi</span>
          <h1>Simpan tempat penting dan tampilkan pengingat yang lebih relevan.</h1>
        </div>
      </header>

      <div className="dual-panel-grid">
        <section className="compact-panel">
          <div className="compact-panel__header">
            <div>
              <span className="eyebrow">Saved places</span>
              <h3>Lokasi favorit</h3>
            </div>
          </div>
          <div className="saved-list">
            {favoritePlaces.map((item) => (
              <article className="saved-item" key={item.name}>
                <div className="saved-item__score">{item.score}</div>
                <div>
                  <strong>{item.name}</strong>
                  <p>{item.note}</p>
                </div>
                <button className="button button--ghost button--small" type="button">Lihat</button>
              </article>
            ))}
          </div>
        </section>

        <section className="compact-panel">
          <div className="compact-panel__header">
            <div>
              <span className="eyebrow">Smart reminder</span>
              <h3>Notifikasi prioritas</h3>
            </div>
          </div>
          <div className="notification-list">
            {notifications.map((item) => (
              <article className="notification-item" key={item.title}>
                <span>✦</span>
                <div>
                  <strong>{item.title}</strong>
                  <p>{item.body}</p>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
